'use strict';

// Sets up app configuration on compile for target environment

export const API_ROOT = `${process.env.BASE_API_URL}`;

if (process.env.NODE_ENV !== 'production') {
  console.log('Using API on', API_ROOT);
}



// WEBPACK FOOTER //
// ./src/config.js